import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, useEventCallback } from '@mui/material';
import { useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import {
  AccordionCancelMarriage,
  CancelMarriageFormVM,
} from 'mutation/view-models/cancel-marriage';
import CancelMarriageForm from './form';
import { FormikErrors, FormikTouched } from 'formik';

const CivilStatus = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<CancelMarriageFormVM>();

  const onFieldCancelMarriageChange = useEventCallback(
    (
      key: keyof AccordionCancelMarriage,
      value: AccordionCancelMarriage[keyof AccordionCancelMarriage]
    ) => {
      formContext.setFieldValue('cancelMarriage', {
        ...formContext.values.cancelMarriage,
        [key]: value,
      });
    }
  );

  const onFieldsCancelMarriageChange = useEventCallback((values: AccordionCancelMarriage) => {
    formContext.setFieldValue('cancelMarriage', {
      ...formContext.values.cancelMarriage,
      ...values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-cancel-marriage-content"
        id="panel-person-cancel-marriage-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.cancelMarriage ? <Close color="error" /> : <Check color="success" />}
        <AccordionTitle>Cessazione matrimonio</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <CancelMarriageForm
          values={formContext.values.cancelMarriage}
          onChange={onFieldCancelMarriageChange}
          errors={formContext.errors.cancelMarriage as FormikErrors<AccordionCancelMarriage>}
          touched={
            formContext.touched.cancelMarriage as unknown as FormikTouched<AccordionCancelMarriage>
          }
          onChangeValues={onFieldsCancelMarriageChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilStatus.displayName = 'Accordion cancel marriage component';

export default CivilStatus;
